import { logg } from './helper'

/**
 * @description Generacion de path con parametros
 * @param path
 * @param params
 * @param prefix
 */
export const genPath = (
  path: string,
  params: { [key: string]: string },
  prefix = ':',
) => {
  try {
    let newPath = path
    Object.entries(params).forEach(([key, value]) => {
      newPath = newPath.replace(`${prefix}${key}`, value)
    })
    return newPath
  } catch (e: any) {
    logg('Error in replacePathParams: ' + e.message)
    return ''
  }
}
